import { Component, OnInit } from '@angular/core';
import { MenuService } from './core/services/menu.service';
import { NavItem } from './core/interfaces/nav-item.interface';
import { TranslocoService } from '@ngneat/transloco';
import { environment } from 'src/environments/environment';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'cs-gui';

  public navItems: NavItem[] = [];

  constructor(
    private menuService: MenuService,
    private translocoService: TranslocoService,
    private userService: UserService
  ) {
    this.navItems = [];
  }

  async ngOnInit() {
    window.ineum('key', environment.instanaKey);
    this.getMenuItems();
    const localLang = localStorage.getItem('translocoLang');
    if (!localLang) {
      if (navigator.language) {
        this.translocoService.setActiveLang(navigator.language.slice(0, 2));
      }
    } else {
      this.translocoService.setActiveLang(localLang);
    }
  }

  getMenuItems(mobile: boolean = false) {
    this.userService.getUser().then((value: any) => {
      value.subscribe((user: any) => {
        let community_shop = false;
        if (user != null) {
          window.ineum('user', user.name, user.email);
          community_shop = user.roles.indexOf(this.userService.ROLE_VIEW_COMMUNITY_SHOP) > -1;
        }
        this.menuService.getMenuItems().then((res: any) => {
          this.navItems = res;
        });
      });
    });
  }
}
